module.exports = __webpack_public_path__ + "static/media/second_place_dark.0b3b2447.svg";